module.exports = function() {
  return new Worker(__webpack_public_path__ + "4162a08397af4da3bb79.worker.js");
};